import React from "react";
import UndrawArticles from "../assets/undraw_articles_wbpb.svg";
import { Link } from "react-router-dom";

const Articles = () => {
  return (
    <div
      id="articles"
      className="bgHome  border-bottom border-opacity-25 border-secondary border-3 shadow"
    >
      <div className="container ">
        <div className="row  d-flex justify-content-center  align-items-center ">
          <div className="col-md-5 col-8  pt-3 d-flex justify-content-center  align-items-center ">
            <img className="w-100" src={UndrawArticles} alt="" />
          </div>

          <div className="col-md-7  d-flex justify-content-center flex-column align-items-center pt-5 pt-lg-0">
            <h2 className="pb-1 fw-bold after position-relative">
              <Link className="nav-link " to="/articles">
                Psychiatric Illness
              </Link>
            </h2>
            <div className="w-75 bg-light border-bottom border-opacity-25 border-secondary border-3 shadow rounded-4 p-3 mt-4 ">
              <p>
                These articles provide a comprehensive review of the current
                literature on psychiatric illness, aiming to enhance
                understanding of the various aspects of mental health disorders.
                The review encompasses a wide range of psychiatric conditions,
                including but not limited to depression, anxiety disorders,
                bipolar disorder, schizophrenia, and personality disorders.
              </p>
            </div>
            <button className="px-3 py-2 mt-5 mb-xxl-0 mb-4 btnCustom rounded-5">
              <Link
                className="nav-link "
                style={{ color: "#EEE" }}
                to="/articles"
              >
                READ More
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;
